import { Link } from '@reach/router';
import React from 'react';
import { Button, Card } from '../components/ui';

const NotFound = () => (
  <div className="absolute absolute--fill flex-auto flex justify-center items-center tc pa3">
    <Card>
      <div className="pa3 pa4-ns">
        <h1 className="display f3  mt2 mb0">Whoops</h1>
        <p className="f6 mt2 lh-copy">We couldn&rsquo;t find the page you&rsquo;re looking for.</p>
      </div>
      <Link to="/" className="bt b--light-gray db pv3 f6 blue hover-navy">
        Back to Spaces
      </Link>
    </Card>
  </div>
);

export default NotFound;
